import Swiper, { Pagination, Navigation } from "swiper";
import { updateLazy } from "../functions/lazy";

import "Layouts/default";

import "Ui/slider";

import "Common/social";
import "Common/lightgallery";

Swiper.use([Pagination, Navigation]);

document.addEventListener("DOMContentLoaded", function () {
    updateLazy();
});
